'use client';

import { useAuth } from '@/lib/auth-context';

export function ShowSensitiveToggle() {
  const { role, isLoading, showSensitive, toggleShowSensitive } = useAuth();

  if (isLoading || (role !== 'admin' && role !== 'trusted')) {
    return null;
  }

  return (
    <button
      onClick={toggleShowSensitive}
      title={showSensitive ? 'Hide sensitive content' : 'Show sensitive content'}
      className={`ml-3 px-3 py-2 text-sm font-medium transition-colors ${
        showSensitive
          ? 'text-white hover:text-zinc-300'
          : 'text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100'
      }`}
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        {showSensitive ? (
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        ) : (
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l18 18" />
        )}
      </svg>
    </button>
  );
}
